export const CATALOG_TAXONOMY_COLLECTION = 'catalogTaxonomy'

export const NODE_SCHEMA_VERSION = 1

export const NODE_TYPE = {
  GLOBAL: 'global',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
}

export const NODE_DEPTH = {
  [NODE_TYPE.GLOBAL]: 0,
  [NODE_TYPE.CATEGORY]: 1,
  [NODE_TYPE.SUBCATEGORY]: 2,
}

export const COLUMN_TITLES = {
  [NODE_TYPE.GLOBAL]: 'Глобальні категорії',
  [NODE_TYPE.CATEGORY]: 'Категорії',
  [NODE_TYPE.SUBCATEGORY]: 'Підкатегорії',
}

export const NODE_TYPE_LABEL_GENITIVE = {
  [NODE_TYPE.GLOBAL]: 'глобальну категорію',
  [NODE_TYPE.CATEGORY]: 'категорію',
  [NODE_TYPE.SUBCATEGORY]: 'підкатегорію',
}

export const editorTitleForNodeType = (type, mode = 'edit') => {
  const label = NODE_TYPE_LABEL_GENITIVE[type]
  if (!label) return mode === 'create' ? 'Додати' : 'Редагувати'
  return mode === 'create' ? `Додати ${label}` : `Редагувати ${label}`
}

export const isValidNodeType = (type) => Object.values(NODE_TYPE).includes(type)

export const depthForType = (type) => NODE_DEPTH[type]

export const isValidParentForType = (type, parentId) => {
  if (type === NODE_TYPE.GLOBAL) {
    return parentId === null || parentId === undefined
  }
  if (type === NODE_TYPE.CATEGORY || type === NODE_TYPE.SUBCATEGORY) {
    return typeof parentId === 'string' && parentId.length > 0
  }
  return false
}

/** Parent type expected when moving / creating under a parent. */
export const expectedParentType = (childType) => {
  if (childType === NODE_TYPE.CATEGORY) return NODE_TYPE.GLOBAL
  if (childType === NODE_TYPE.SUBCATEGORY) return NODE_TYPE.CATEGORY
  return null
}
